import { Button, CardActions, useTheme } from "@mui/material";

import { Strings } from "@app/constants";

interface VehicleActionsProps {
  onViewDetails?: () => void;
}

const VehicleActions = ({ onViewDetails }: VehicleActionsProps) => {
  const theme = useTheme();
  return (
    <CardActions sx={{ px: 0, pb: 2 }}>
      <Button
        variant="contained"
        fullWidth
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: "white",
          fontSize: { xs: 12, sm: 14 },
          fontWeight: 600,
          py: { xs: 1, sm: 1.5 },
        }}
        onClick={onViewDetails}
      >
        {Strings.home.viewDetails}
      </Button>
    </CardActions>
  );
};

export { VehicleActions };
